var Component            = require("enyo/Component"),
    config               = require("app/config"),
    ConfirmActivityPopup = require("app/MediaPlayer/ConfirmActivityPopup"),
    get                  = require("object-path").get,
    kind                 = require("enyo/kind"),
    throttle             = require("enyo-perf/utils").throttle;

module.exports = kind(/** @lends  app.AutoplayTimer.AutoplayTimerService.prototype */ {

    /**
     * @private
     */
    name: "app.AutoplayTimer.AutoplayTimerService",

    /**
     * @private
     */
    kind: Component,

    /**
     * @private
     */
    timer: null,

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.onTimeout         = this.bindSafely(this.onTimeout);
            this.onUserInteraction = this.bindSafely(this.onUserInteraction);
            this.resetTimer        = throttle(this.bindSafely(this.resetTimer), 1000);
            sup.apply(this, arguments);
        };
    }),

    /**
     * @param  {number=}  duration  Optional timeout duration in seconds
     * @public
     */
    startTimer: function(duration) {
        if (this.timer) {
            return;
        }

        // Start timer
        if (duration) {
            this.timer = setTimeout(this.onTimeout, 1000 * duration);
        }
        else {
            this.timer = setTimeout(this.onTimeout, 1000 * get(config, "autoplay.timeout", 7200));
        }

        // Check for user interaction
        document.addEventListener("pointerdown", this.onUserInteraction);
        document.addEventListener("keydown", this.onUserInteraction);
        document.addEventListener("wheel", this.onUserInteraction);

        // We can't track events inside an iframe, but we can detect if an
        // iframe received focus.
        window.addEventListener("focus", this.onUserInteraction);
        window.addEventListener("blur", this.onUserInteraction);
    },

    /**
     * Reset the timer, if it's running.
     *
     * @public
     */
    resetTimer: function() {
        if (!this.timer) {
            return;
        }

        this.stopTimer();

        if (this.app.$.state.get("mediaPlayerPlaying")) {
            this.startTimer();
        }
    },

    /**
     * @public
     */
    stopTimer: function() {
        if (!this.timer) {
            return;
        }

        // Clear timer
        clearTimeout(this.timer);
        this.timer = null;

        // Stop checking for user interaction
        document.removeEventListener("pointerdown", this.onUserInteraction);
        document.removeEventListener("keydown", this.onUserInteraction);
        document.removeEventListener("wheel", this.onUserInteraction);

        // We can't track events inside an iframe, but we can detect if an
        // iframe received focus.
        window.removeEventListener("focus", this.onUserInteraction);
        window.removeEventListener("blur", this.onUserInteraction);
    },

    /**
     * @private
     */
    onUserInteraction: function() {
        this.resetTimer();
    },

    /**
     * @private
     */
    onTimeout: function() {
        var mediaPlayerPlaying = this.app.$.state.get("mediaPlayerPlaying");

        this.stopTimer();

        // If we are showing a video on screen, pause it and show the
        // confirmation popup.
        if (mediaPlayerPlaying) {
            this.pauseMediaPlayer();
            this.showPopup();
        }

        // If the player is currently loading, buffering, etc. It looks kinda
        // weird to ask for confirmation that someone is still watching.
        // Especially if it happens during loading of a new video. So, let's add
        // another 30 seconds to the timer to allow the video to get into a
        // playing state first before we start asking.
        else {
            this.startTimer(30);
        }
    },

    /**
     * @private
     */
    pauseMediaPlayer: function() {
        var mediaPlayer = this.app.$.state.get("mediaPlayer");

        mediaPlayer && mediaPlayer.pause();
    },

    /**
     * @private
     */
    showPopup: function() {
        var message;

        if (!this.$.popup) {
            message = this.createComponent({
                name: "popup",
                kind: ConfirmActivityPopup
            });
            message.render();
            message.requestShow(true, false);
            message.on("hidden", function() {
                message.destroy();
            });
        }
    }

});
